<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="" name='keywords'>
          <a-input-group compact :style="{width:'360px'}">
            <a-select v-model:value="search.type" style="width: 30%" @change="inputSelect">
              <a-select-option value="dealer_sn">客户名称</a-select-option>
              <a-select-option value="dealer_name">手机号</a-select-option>
              <a-select-option value="leader_name">所属门店</a-select-option>
              <a-select-option value="leader_phone">所属上级</a-select-option>
              <!-- <a-select-option value="leader_wx">微信号</a-select-option> -->
            </a-select>
            <a-input style="width: 70%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
          </a-input-group>
        </a-form-item>
        <a-form-item label="首次登录时间" name='time'>
          <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
        </a-form-item>
        <a-form-item label="最近登录时间" name='time'>
          <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
        </a-form-item>
        <a-form-item label="类型" name='keywords' >
          <a-select v-model:value="search.type" style="width:100px" >
            <a-select-option value="dealer_sn">全部</a-select-option>
            <a-select-option value="dealer_name">门店</a-select-option>
            <a-select-option value="leader_name">经销商</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
      </a-form>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='list'>
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
    </a-card>
  </a-layout>
</template>
<script>
import { ref, inject, reactive, toRefs, onMounted } from "vue";
import { getPublicLevelList, getPublicTypeList, getStoreList } from "@/api/store";
import { iscode } from "@/utils/app";
import store from "@/store";
import useTableSearch from "@/hooks/useTableSearch";
import { message } from "ant-design-vue";
// 初始化默认筛选项数值
let defSearch = {
  page: 1,
  limit: 10,
  product_name: "",
};
export default {
  components: {},
  setup(props, ctx) {
    let columns = [
      {
        title: "客户名称",
        dataIndex: "store_code",
        key: "store_code",
      },
      {
        title: "手机号码",
        dataIndex: "store_name",
        key: "store_name",
      },
      {
        title: "类型",
        dataIndex: "address",
        key: "address",
      },
      {
        title: "所属门店",
        dataIndex: "distributor_name",
        key: "distributor_name",
      },
      {
        title: "所属上级",
        dataIndex: "distributor_name",
        key: "distributor_name",
      },
      {
        title: "首次登录时间",
        dataIndex: "clerk_name",
        key: "clerk_name",
      },
      {
        title: "最近登录时间",
        dataIndex: "status_text",
        key: "status_text",
        width: 100,
      },
    ];
    const state = reactive({
      typeList: [],
      levelList: [],
    });
    // 获取类型列表
    const getType = async () => {
      let res = await getPublicTypeList().then((res) => res.data);
      if (iscode(res)) {
        state.typeList = res.data.data;
      } else {
        message.error(res.msg);
      }
    };
    //获取等级列表
    const getLvevl = async () => {
      let res = await getPublicLevelList().then((res) => res.data);
      if (iscode(res)) {
        state.levelList = res.data.data;
      } else {
        message.error(res.msg);
      }
    };
    const {
      pageCurrentChange,
      pageSizeChange,
      search,
      list,
      initData,
      total,
      pageSearchChange,
      listLoading,
    } = useTableSearch({ data: defSearch });
    const tableHoosks = {
      pageCurrentChange,
      pageSizeChange,
      search,
      initData,
      list,
      total,
      pageSearchChange,
      listLoading,
    };
    onMounted(() => {
      tableHoosks.initData(getStoreList, search.value);
      getType();
      getLvevl();
    });
    const form = ref();
    return {
      info: store.state.user.info,
      ...toRefs(state),
      ...tableHoosks,
      columns,
      form,
    };
  },
};
</script>